import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import CalcImg from '../../assets/images/calc.svg';
import InfoDefault from '../../assets/icons/info-default.svg';
import InfoHovered from '../../assets/icons/info-hover.svg';
import './calculator.scss';
import { Link } from 'react-scroll';
import { CalculatorInputRub, NumberInput } from '../NumberInput/NumberInput';
import ReactTooltip from 'react-tooltip';

const Calculator = () => {
  const [cubValue, setCubValue] = useState<number | undefined>(50);
  const [deskValue, setDeskValue] = useState<number | undefined>();
  const [gigantValue, setGigantValue] = useState<number | undefined>();
  const [investment, setInvestment] = useState(0);
  const [income, setIncome] = useState(0);

  useEffect(() => {
    const investmentCount =
      (cubValue || 0) * 34800 + (deskValue && deskValue || 0) * 162000 + (gigantValue && gigantValue || 0) * 290000;
    const incomeCount =
      (cubValue || 0) * 5184 + (deskValue && deskValue || 0) * 16560 + (gigantValue && gigantValue || 0) * 38880;
    setInvestment(investmentCount);
    setIncome(incomeCount);
  }, [cubValue, deskValue, gigantValue, investment]);


  const onChange = (
    value: string,
    func: React.Dispatch<React.SetStateAction<number | undefined>>
  ) => {
    if (Number(value) > 0) {
      func(parseInt(value, 10));
    } else {
      func(undefined);
    }
  };
  const onUpArrow = (func: React.Dispatch<React.SetStateAction<number | undefined>>) => {
    func((value) => value && value + 1);
  };
  const onDownArrow = (func: React.Dispatch<React.SetStateAction<number | undefined>>) => {
    func((value) => (value && value > 0 ? value - 1 : 0));
  };
  return (
    <CalculatorBlock>
      <CalculatorContainer>
        <CalculatorTitles>
          <CalculatorSubtitle>Оборудование</CalculatorSubtitle>
          <CalculatorSubtitleSecond>Количество, штук</CalculatorSubtitleSecond>
        </CalculatorTitles>
        <CalculatorRow>
          <CalculatorItem>
            <CalculatorItemTitle>Кубик</CalculatorItemTitle>
            <CalculatorItemSubTitle>8 слотов</CalculatorItemSubTitle>
          </CalculatorItem>
          <NumberInput
            value={cubValue}
            onChange={onChange}
            onUpArrow={onUpArrow}
            onDownArrow={onDownArrow}
            func={setCubValue}
          />
        </CalculatorRow>
        <CalculatorRow>
          <CalculatorItem>
            <CalculatorItemTitle>Стойка</CalculatorItemTitle>
            <CalculatorItemSubTitle>24 слота</CalculatorItemSubTitle>
          </CalculatorItem>
          <NumberInput
            value={deskValue}
            onChange={onChange}
            onUpArrow={onUpArrow}
            onDownArrow={onDownArrow}
            func={setDeskValue}
          />
        </CalculatorRow>
        <CalculatorRow>
          <CalculatorItem>
            <CalculatorItemTitle>Гигант</CalculatorItemTitle>
            <CalculatorItemSubTitle>48 слотов</CalculatorItemSubTitle>
          </CalculatorItem>
          <NumberInput
            value={gigantValue}
            onChange={onChange}
            onUpArrow={onUpArrow}
            onDownArrow={onDownArrow}
            func={setGigantValue}
          />
        </CalculatorRow>
        <CalculatorRow>
          <CalculatorItem>
            <CalculatorItemTitle>Инвестиции</CalculatorItemTitle>
          </CalculatorItem>
          <CalculatorInputRub
            type="number"
            min={0}
            value={investment}
            onChange={() => ''}
          />
          <RubleText>руб</RubleText>
        </CalculatorRow>
        <CalculatorRow>
          <CalculatorSalary>
            Ежемесячная выручка
            <img
              data-tip="c 13го месяца работы"
              src={InfoDefault}
              onMouseEnter={(e) => {
                (e.currentTarget.src = `${InfoHovered}`),
                  ReactTooltip.show(e.currentTarget);
              }}
              onMouseLeave={(e) => (e.currentTarget.src = `${InfoDefault}`)}
              style={{ cursor: 'pointer', marginLeft: '10px' }}
              alt="info"
            />
            <ReactTooltip />
          </CalculatorSalary>
          <CalculatorInputRub
            style={{ color: 'red', fontWeight: 700 }}
            type="number"
            min={0}
            value={income}
            onChange={() => ''}
          />
          <RubleText>руб</RubleText>
        </CalculatorRow>
      </CalculatorContainer>
      <CalculatorMedia>
        <img
          style={{ marginBottom: '33px' }}
          src={CalcImg}
          alt="calcultor-logo"
        />
        <Link to="contact-form">
          <RedButton style={{ width: '288px' }}>
            Заявка на франшизу
          </RedButton>
        </Link>
      </CalculatorMedia>
    </CalculatorBlock>
  );
};

const CalculatorBlock = styled.div`
  display: flex;
  @media (max-width: 1135px) {
    flex-direction: column;
    align-items: center;
    margin-bottom: -24px;
  }
`;

const CalculatorContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 48%;
  margin-top: 50px;
  @media (max-width: 1440px) {
    width: 51%;
  }
  @media (max-width: 1135px) {
    width: 100%;
  }
  @media (max-width: 599px) {
    margin-top: 42px;
  }
`;

const CalculatorMedia = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 28%;
  margin-top: 34px;
  margin-left: 19.6%;
  @media (max-width: 1440px) {
    margin-left: 17.5%;
  }
  @media (max-width: 1135px) {
    margin-left: 0;
    margin-top: 21px;
    & img {
      display: none;
    }
  }
`;

const CalculatorRow = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  height: 64px;
`;

const CalculatorItem = styled.div`
  display: flex;
  align-items: center;
  border: 2px solid #e7e8eb;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 24px;
  height: 100%;
  width: 62%;
  @media (max-width: 600px) {
    width: 48%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }
  @media (max-width: 360px) {
    padding: 12px;
  }
`;

const CalculatorSalary = styled.span`
  width: 62%;
  font-weight: 700;
  font-size: 28px;
  @media (max-width: 600px) {
    width: 50%;
    font-size: 20px;
    line-height: 24px;
  }
`;

const CalculatorItemTitle = styled.span`
  color: #26292d;
  font-weight: 700;
  @media (max-width: 600px) {
    font-size: 20px;
  }
`;

const CalculatorItemSubTitle = styled.span`
  color: #a2a8b0;
  font-weight: 400;
  margin-left: 12px;
  @media (max-width: 600px) {
    font-size: 20px;
    margin-left: 0px;
  }
  @media (max-width: 450px) {
    font-size: 18px;
  }
`;

const CalculatorSubtitle = styled.span`
  font-weight: 400;
  font-size: 20px;
  color: #a2a8b0;
  width: 62%;
  @media (max-width: 599px) {
    width: 48%;
  }
`;

const CalculatorSubtitleSecond = styled.span`
  font-weight: 400;
  font-size: 20px;
  color: #a2a8b0;
  width: 208px;
  @media (max-width: 1135px) {
    width: 33%;
  }
  @media (max-width: 599px) {
    width: 48%;
  }
`;

const CalculatorTitles = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

const RubleText = styled.i`
  position: absolute;
  right: 25px;
  color: #a2a8b0;
  font-weight: 400;
  font-size: 24px;
  @media (max-width: 400px) {
    right: 10px;
  }
  @media (max-width: 360px) {
    right: 5px;
  }
`;

export const RedButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 32px;
  background: #e30613;
  border-radius: 8px;
  font-weight: 700;
  font-size: 20px;
  color: #ffffff;
  height: 64px;
  &:hover {
    background: #98040d;
  }
`;

export default Calculator;
